import React from 'react';

export default function Skeleton({ width = '100%', height = '20px', style }) {
  return (
    <div
      role="status"
      aria-label="در حال بارگذاری"
      style={{
        width, height, borderRadius: '8px',
        background: 'linear-gradient(90deg, var(--muted) 25%, var(--border) 37%, var(--muted) 63%)',
        backgroundSize: '400% 100%',
        animation: 'shimmer 1.4s ease infinite',
        ...style,
      }}
    />
  );
}